module.exports = __webpack_public_path__ + "img/Andy.af1fdfbc.jpg";